<script lang="ts">
    import HeaderSortableColumn from '../../../shared/HeaderSortableColumn.svelte';
    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import './JobOne2.css';
    import { _ } from 'svelte-i18n';
    import { app } from '../../../../stores/app';

    export let jobFilter: ApiFilterBuilder;
    export let onFilterChange: () => void;
    export let simpleView: boolean = false;
</script>

<div class="order-element-v2 order-element-v2-header" class:simple-view={simpleView}>
    <!--    <div class="checkbox">-->
    <!--        <Checkbox-->
    <!--            label=""-->
    <!--            checked={$jobs.selectMode === 'filtered'}-->
    <!--            onChange={v => {-->
    <!--                if ($jobs.selectMode === 'selected') {-->
    <!--                    $jobs.selectMode = 'filtered';-->
    <!--                    $jobs.selectedOrUnselected = [];-->
    <!--                } else {-->
    <!--                    $jobs.selectMode = 'selected';-->
    <!--                    $jobs.selectedOrUnselected = [];-->
    <!--                }-->
    <!--            }}-->
    <!--        />-->
    <!--    </div>-->
    <HeaderSortableColumn {jobFilter} {onFilterChange} label={$_('type')} className="location_type" fieldName="location_type" />
    <HeaderSortableColumn
        {jobFilter}
        {onFilterChange}
        label={$app.settingsReadonly?.short_name_instead_of_unique_id ? $_('ext_id') : $_('Unique id')}
        className="ext_id"
        fieldName="ext_id"
    />
    <HeaderSortableColumn {jobFilter} {onFilterChange} label={$_('full_name')} className="full_name" fieldName="full_name" />
    <HeaderSortableColumn {jobFilter} {onFilterChange} label={$_('pcode')} className="pcode" fieldName="address_attributes.pcode" />
    <HeaderSortableColumn {jobFilter} {onFilterChange} label={$_('city')} className="city" fieldName="address_attributes.city" />
    <HeaderSortableColumn {jobFilter} {onFilterChange} label={$_('street')} className="street" fieldName="address_attributes.street" />
    <HeaderSortableColumn {jobFilter} {onFilterChange} label={$_('Uwagi')} className="uwagi" fieldName={null} />
</div>
